/**
 * Event-type buckets shared across the events UI.
 *
 * "File" events (path-watch / SSH) have their own instances page and raise
 * endpoint; everything else is treated as a process event. Both spellings are
 * recognised — the camelCase API type and the snake_case legacy form. A
 * nullish type is not a file event.
 */
export const isFileEventType = (type?: string | null): boolean =>
  type === 'fileEvent' || type === 'fileEventSSH' || type === 'file_event' || type === 'file_event_ssh';
